export default function computeInternalGap(
  analysis: {
    id: string;
    date: number;
    quantityValues: {
      [quantityId: string]: {
        measured: number;
        simulated: number | null;
      };
    };
  },
  quantityId: string,
  offset: number,
): number | null {
  const qv = analysis.quantityValues[quantityId];
  if (qv === undefined || qv.simulated === null) return null;

  return qv.measured - (qv.simulated + offset);
}
